  <template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>仓库名称：</p>
        <el-input v-model="nameIpt" size="mini" style="width:150px" placeholder="请输入仓库名称"/>
      </div>
      <div class="navContainer">
        <p>楼层：</p>
        <el-input v-model="floorIpt" size="mini" style="width:150px" placeholder="请输入楼层"/>
      </div>
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width:150px" placeholder="请选择状态">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">添加楼层</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{scope.$index+1}}</div>
          </el-table-column>
          <el-table-column prop="storehouseName" label="仓库名称" align="center"/>
          <el-table-column prop="floorName" label="楼层名称" align="center"/>
          <el-table-column prop="sort" label="排序" align="center"/>
          <el-table-column label="状态" align="center">
            <div slot-scope="scope">{{getState(scope.row.status)}}</div>
          </el-table-column>
          <el-table-column label="操作" width="360" align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;padding-left: 10px">
                <el-button v-if="scope.row.status" size="mini" type="danger" @click="disableClick(scope.row.id)">禁用</el-button>
                <el-button v-else size="mini" type="primary" @click="enableClick(scope.row.id)">启用</el-button>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情</el-button>
                <el-button size="mini" class="resetBtn" type="primary" @click="indexClick(scope.$index, scope.row)">修改排序</el-button>
                <el-button size="mini" type="primary" @click="changeClick(scope.row)" class="yellow-bg">修改</el-button>
                <el-button size="mini" type="info" @click="deleteClick(scope.row.id)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情楼层" :visible.sync="detailDialogVisible" width='600px' center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <p>{{detailData.state}}</p>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">所属仓库：</span>
              <span>{{detailData.storehouseName}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">楼层名称：</span>
              <span>{{detailData.floorName}}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">车位总数量：</span>
                <span>{{detailData.parkingTotal}}</span>
              </div>
              <div>
                <span class="span1">空闲车位：</span>
                <span>{{detailData.parkingFree}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">已停车位：</span>
                <span>{{detailData.parkingUse}}</span>
              </div>
              <div>
                <span class="span1">暂停车位：</span>
                <span>{{detailData.parkingSuspend}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{getTime(scope.row.createTime)}}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center"/>
              <el-table-column prop="operationName" label="操作人" align="center"/>
              <el-table-column prop="remark" label="备注" align="center"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='550px' center @close="dialogClose" :close-on-click-modal="false">
      <div class="company">
        <el-form :model="companyData" label-width="95px" :rules="rules" ref="ruleForm">
          <el-form-item label="仓库名称：" prop="warehouse">
            <el-input
              :style="'width:100%'"
              v-model="companyData.warehouse"
              placeholder="请输入仓库名称"
              autocomplete="off"
              size="small"
            />
            <hr color="#F0F0F2"/>
          </el-form-item>
          <el-form-item label="楼层名称：" prop="floor">
            <el-input
              :style="'width:100%'"
              v-model="companyData.floor"
              placeholder="请输入楼层名称"
              autocomplete="off"
              size="small"
            />
            <hr color="#F0F0F2"/>
          </el-form-item>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick">确认</el-button>
            <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="修改排序" :visible.sync="indexDialogVisible" width='600px' center :close-on-click-modal="false">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <p>{{detailData.state}}</p>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">所属仓库：</span>
              <span>{{detailData.warehouse}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">楼层名称：</span>
              <span>{{detailData.floor}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">车位总数量：</span>
              <span>{{detailData.total}}</span>
            </div>
            <div class="baseInfoContentItem specialItem" style="justify-content:space-between">
              <div>
                <span class="span1">空闲车位数量：</span>
                <span>{{detailData.free}}</span>
              </div>
              <div>
                <span class="span1">已满车位数量：</span>
                <span>{{detailData.full}}</span>
              </div>
              <div>
                <span class="span1">暂停使用车位数量：</span>
                <span>{{detailData.pause}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>修改排序</span>
          </div>
          <div class="operationTable">
            <el-table :data="indexData" border stripe>
              <el-table-column prop="index" label="排序" align="center"/>
              <el-table-column prop="floor" label="楼层名称" align="center"/>
              <el-table-column label="操作" align="center" width="100px">
                <template slot-scope="scope">
                  <div class="operationIndex">
                    <span @click="moveClick(scope.$index,1)">上移</span>
                    <span @click="moveClick(scope.$index,0)">下移</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {formatDateTime, removeSpace} from "@/config/mUtils";
import {
  floorList,
  floorIsEnable,
  deleteFloor,
  addFloor,
  updateFloor,
  floorDetail,
} from "@/service/basicfile"
export default {
  components: {
  },
  data() {
    return {
      nameIpt:'',
      floorIpt:'',
      stateIpt:'',
      stateOption:[
        {value:'',label:'全部',},
        {value:1,label:'启用中'},
        {value:0,label:'禁用中'},
      ],
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[],
      detailDialogVisible:false,
      detailData:{state:'启动中',warehouse:'仓库1',floor:'-1',total:'10',free:'30',full:'30',pause:'60'},
      operationData:[
        {operateTime:'2021-8-31 15:49:58',operateType:'启用',account:'王三文',remark:''},
        {operateTime:'2021-8-31 15:49:58',operateType:'禁用',account:'张三丰',remark:''},
        {operateTime:'2021-8-31 15:49:58',operateType:'添加',account:'赵兮雪',remark:''},
      ],
      dialogTitle:'',
      dialogVisible:false,
      addLoad:false,
      companyData:{
        warehouse:'',
        floor:'',
      },
      areaOption1:[
        {value:'重庆市-渝北区',label:'重庆市-渝北区'},
        {value:'重庆市-九龙坡区',label:'重庆市-九龙坡区'},
      ],
      rules:{
        warehouse:[
          { required: true, message: '请输入仓库名字', trigger: 'blur' },
        ],
        floor:[
          { required: true, message: '请输入楼层', trigger: 'blur' },
        ],
      },
      indexDialogVisible:false,
      indexData:[
        {index:1,floor:'-1'},
        {index:2,floor:'-2'},
        {index:3,floor:'-3'},
      ],
    };
  },
  computed:{
    getState(){
      return function(state){
        switch(state) {
          case 1:
            return '启用中'
          case 0:
            return '禁用中'
        }
      };
    },
    getTime(){
      return function(time){
        return formatDateTime(time,'yyyy年mm月dd日 hh:ii:ss')
      };
    },
  },
  mounted() {
    this._floorList();
  },
  methods: {
    async _floorList() {
      this.tableLoad = true;
      const obj = {
        storehouseName: this.nameIpt,
        floorName: this.floorIpt,
        status: this.stateIpt,
        rows: this.size,
        page: this.page,
      };
      const res = await floorList(obj);
      this.tableLoad = false;
      if (res.status !== 0) return this.$message.error(res.message);
      this.TableDatas = res.data.records;
      this.total = res.data.total;
    },
    contractSizeChange(sizes){
      this.size=sizes;
      this._floorList();
    },
    contractCurrentChange(page){
      this.page=page;
      this._floorList();
    },
    disableClick(id){
      this.$confirm('确定要禁用当前楼层吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await floorIsEnable(id);
        if(res.status !== 0) return this.$message.error(res.message);
        else this.$message.success(res.message);
        await this._floorList();
      }).catch(() => {});
    },
    deleteClick(id){
      this.$confirm('确定要删除当前楼层吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await deleteFloor(id);
        if(res.status !== 0) return this.$message.error(res.message);
        else this.$message.success(res.message);
        await this._floorList();
      }).catch(() => {});
    },
    indexClick(){
      this.indexDialogVisible=true;
    },
    async detailClick(id) {
      const res = await floorDetail(id);
      if(res.status !== 0) return this.$message.error(res.message);
      this.detailData=res.data;
      this.operationData=res.data.operateRecordList;
      this.detailDialogVisible = true;
    },
    changeClick(item){
      this.companyData={
        ...item,
        warehouse:item.storehouseId,
        floor:item.floorName,
      };
      this.dialogTitle='修改楼层';
      this.dialogVisible=true;
    },
    searchBtn(){
      this.page = 1;
      this._floorList();
    },
    resetBtn(){
      this.nameIpt='';
      this.floorIpt='';
      this.stateIpt='';
    },
    addBtn(){
      this.dialogTitle='添加楼层';
      this.dialogVisible=true;
      this.companyData={
        fullName:'',
        referred:'',
        tell:'',
        area:'',
        address:'',
        name:'',
        nameTell:'',
      };
    },
    addClick(){
      this.companyData=removeSpace(this.companyData);
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.addLoad = true;
          const obj={
            id:this.companyData.id,
            storehouseId:'7f9821d1588b4d3b9858901278d57a2d',
            // storehouseId:this.companyData.warehouse,
            floorName:this.companyData.floor,
          };
          const res = this.dialogTitle==='添加楼层'?await addFloor(obj):await updateFloor(obj);
          this.addLoad = false;
          if(res.status !== 0) return this.$message.error(res.message);
          else this.$message.success(res.message);
          await this._floorList();
          this.dialogVisible=false;
        } else {
          return false;
        }
      });
    },
    enableClick(id){
      this.$confirm('确定要启用当前楼层吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await floorIsEnable(id);
        if(res.status !== 0) return this.$message.error(res.message);
        else this.$message.success(res.message);
        await this._floorList();
      }).catch(() => {});
    },
    dialogClose(){
      this.dialogVisible=false;
      this.companyData={
        fullName:'',
        referred:'',
        tell:'',
        area:'',
        address:'',
        name:'',
        nameTell:'',
      };
      this.$refs.ruleForm.resetFields();
    },
    moveClick(index,val){
      if(val){
        if(index===0) return this.$message.warning("改楼层排序已是第一位！");
      }else{
        if(index===this.indexData.length-1) return this.$message.warning("改楼层排序已是最后一位！");
      }
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  background-color: #fff;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height:80vh;
    overflow: auto;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
          align-items:center;
          //justify-content: space-between;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
        .operationIndex{
          display:flex;
          align-items: center;
          justify-content:space-around;
          span{
            color: rgba(58, 98, 215, 1);
            text-decoration: underline;
            font-size: 14px;
            &:hover{
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .company{
    width:100%;
    padding: 20px 10px;
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-input__inner{
        border: none;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    hr{
      margin: 0;
      position: absolute;
      width: 100%;
      bottom: 5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
